import React from 'react';

const Location = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.99987 16.0624C13.348 16.0624 16.0622 13.3481 16.0622 9.99999C16.0622 6.65184 13.348 3.93762 9.99987 3.93762C6.65172 3.93762 3.9375 6.65184 3.9375 9.99999C3.9375 13.3481 6.65172 16.0624 9.99987 16.0624Z"
        fill="#F9F9F9"
        stroke="#7E50FF"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.99977 10.6736C10.3718 10.6736 10.6734 10.372 10.6734 10C10.6734 9.628 10.3718 9.32642 9.99977 9.32642C9.62775 9.32642 9.32617 9.628 9.32617 10C9.32617 10.372 9.62775 10.6736 9.99977 10.6736Z"
        fill="#F9F9F9"
        stroke="#7E50FF"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.99992 3.93767V1.24329V3.93767ZM9.99992 18.7568V16.0624V18.7568ZM16.0623 10H18.7567H16.0623ZM1.24316 10H3.93755H1.24316Z"
        fill="#F9F9F9"
      />
      <path
        d="M9.99992 3.93767V1.24329M9.99992 18.7568V16.0624M16.0623 10H18.7567M1.24316 10H3.93755"
        stroke="#7E50FF"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default Location;
